module.exports = __webpack_public_path__ + "static/media/EnvPromo-Shot106.9edc5744.jpg";